import { map, Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { BaseHttpService } from "./base.http.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { GenericResponse } from "src/app/shared/models/generics";
import { DateTimeFormatter } from "../utils/datetime.formatter";

@Injectable({
  providedIn: "root",
})
export class TableService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  getItemsWithHeaders<T>(
    url: string,
    pageNumber: number,
    pageSize: number,
    filterType: string,
    checkForce: boolean,
    from: Date,
    to: Date | undefined,
    sortColumn?: string | undefined,
    sortDirection?: string | undefined,
    search?: string,
    language?: string,
    application?: string,
  ): Observable<GenericResponse<T>> {
    let params = new HttpParams()
      .set("FilterType", filterType)
      .set("PageSize", pageSize.toString())
      .set("PageNumber", pageNumber.toString())
      .set("CheckForce", checkForce.toString())
      .set("from", DateTimeFormatter.formatDateToString(from))
      .set("to", DateTimeFormatter.formatDateToString(to ?? null));

    if (sortDirection) {
      params = params.set(
        "sortType",
        sortDirection.charAt(0).toUpperCase() + sortDirection.slice(1),
      );
    }

    if (sortColumn) {
      params = params.set("sortProperty", sortColumn);
    }

    if (search) {
      params = params.set("searchText", search);
    }

    if (language) {
      params = params.set("Language", language);
    }

    if (application) {
      params = params.set("Application", application);
    }

    return this.http
      .get<T[]>(`${this.apiUrl}/api/${url}`, { params, observe: "response" })
      .pipe(
        map((response) => {
          const customResponse: GenericResponse<T> = {
            body: response.body ?? [],
            headers: response.headers,
          };
          return customResponse;
        }),
      );
  }
}
